<div class="cpcontent">

    <h2>KML Testing</h2>
    Select a KML file for processing 
    <filetostring (emitFileAsString)="receiveFileAsString($event)"></filetostring>
    <div #pagemap style="width:100%;height:400px"></div>
    <button class="btn btn-primary" (click)="createPolygon()">Load Googel Map</button>
    <br>FileName: {{fileName}}<br>

    <!-- <pre id="json">{{kmlFileDataAsJson | json}}</pre> -->
    <!-- <pre id="json">{{folder | json}}</pre> -->
    <div class="row">
        <div class="col-md-6">
            File Data: <br>
            <pre id="json">{{KML | json}}</pre>
        </div>
        <div class="col-md-6">
            <pre id="json">{{scenariolayout | json}}</pre>
        </div>
    </div>
</div>